import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

const scheduleDismissibleMessages = (root = document) => {
  root.querySelectorAll?.('[data-dismissible-message-fallback="true"]').forEach((element) => {
    if (element.dataset.dismissibleFallbackScheduled === "true") return

    element.dataset.dismissibleFallbackScheduled = "true"
    window.setTimeout(() => element.remove(), 5000)
  })
}

document.addEventListener("turbo:load", () => scheduleDismissibleMessages())
new MutationObserver(() => scheduleDismissibleMessages()).observe(document.documentElement, {
  childList: true,
  subtree: true
})
scheduleDismissibleMessages()

const applyKioskReportGridColumns = () => {
  const columns = window.innerHeight > window.innerWidth ? "1" : "3"

  document.querySelectorAll(".kiosk-report-grid").forEach((grid) => {
    grid.style.setProperty("--kiosk-columns", columns)
    grid.dataset.kioskColumns = columns
  })
}

applyKioskReportGridColumns()
document.addEventListener("DOMContentLoaded", applyKioskReportGridColumns)
document.addEventListener("turbo:load", applyKioskReportGridColumns)
window.addEventListener("resize", applyKioskReportGridColumns)
